"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _dist = require("@low6dev/react-utils/dist");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  line-height: 1;\n"])));

var StyledBlinker = _styledComponents.default.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 1px;\n  right: -2px;\n  width: 1.5px;\n  height: 3px;\n"])));

var Wrapper = function Wrapper(_ref) {
  var matchTime = _ref.matchTime;
  return matchTime > -1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    children: [matchTime, /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBlinker, {
      src: (0, _dist.createImageCdnLink)("blinker.gif")
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
    skeletonWidth: "30px",
    skeletonHeight: "7px",
    margin: "1px 0 0"
  });
};

var _default = Wrapper;
exports.default = _default;